component = React.createElement
dom = React.DOM
{ Component, PropTypes } = React
classnames = require('classnames')

require('./style.styl')

class Tag extends Component
  @propTypes: {
    tag: PropTypes.object.isRequired
    children: PropTypes.node
  }

  constructor: (props) ->
    @state = {}

  render: ->
    { tag, children, className } = @props
    dom.div {
      className: classnames('Tag', className)
      style: {
        backgroundColor: "##{tag.color}"
      }
    },
      dom.span { className: 'tag-name' }, tag.name
      children

module.exports = Tag



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/Tag/index.coffee